import React from 'react';

import LiteratureSubjectPage from '../containers/LiteratureSubjectPage';

const LiteratureSubjectPageApp = (props) => (
  <LiteratureSubjectPage {...props} />
);

export default LiteratureSubjectPageApp
